import React from "react";
import intl from "react-intl-universal";


import {useAppState} from "@stores/AppStateContext";

import {ModalConfirm} from "../../../components/ModalConfirm";

export interface UserDeleteModalProps {
    confirmWarning: React.ReactNode;
    onConfirm: () => Promise<void>;
}

export const UserDeleteModal = (props: UserDeleteModalProps) => {
    const {
        confirmWarning,
        onConfirm,
    } = props;
    const appState = useAppState();

    const onClose = () => appState.setModal(null);

    return (
        <ModalConfirm
            open={true}
            type={'danger'}
            header={intl.get('confirm.delete_user.title').d('Remove member?')}
            onConfirm={onConfirm}
            confirmText={intl.get('confirm.delete_user.btn').d('Remove')}
            onClose={onClose}
            onCancel={onClose}
        >
            {confirmWarning}
        </ModalConfirm>
    );
}
